import { HttpHeaders, HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from '@core/providers/http/api.service';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ProfissionaisReportService {
  private readonly path = 'profissionais';
  private apiProfissionais = `${environment.apiProfissionaisUrl.replace(/\/+$/, '')}/profissionais`;

  constructor(private api: ApiService, private http: HttpClient) {}

  filtrarProfissionais(params: any): Observable<any> {
    return this.api.get(`${this.path}/info`, params, true);
  }

  sendProfissionaisExcel(params: any): Observable<Blob> {
    const headers = new HttpHeaders().set(
      'Accept',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    );

    const httpParams = new HttpParams({ fromObject: params });

    return this.http.get(`${this.apiProfissionais}/GerarExcelProfissionais`, {
      headers,
      params: httpParams,
      responseType: 'blob',
    });
  }

  sendProfissionaisPDF(params: any): Observable<Blob> {
    const headers = new HttpHeaders().set('Accept', 'application/pdf');
    const httpParams = new HttpParams({ fromObject: params });

    return this.http.get(`${this.apiProfissionais}/Relatorio_Profissionais`, {
      headers,
      params: httpParams,
      responseType: 'blob',
    });
  }
}
